// Module
var code = "<div class=\"u-sizeFullWidth ui-grid-cell-contents\">\n    <div class=\"u-flex u-flexMiddle u-flexSpaced\">\n        <div ng-bind=\"row.entity.Currency ? row.entity.Currency : row.entity.BrandableCurrencyName\"></div>\n    </div>\n</div>\n";
// Exports
module.exports = code;